"use client"

import ButtonPill from "@/app/(site)/_components/Molecules/ButtonPill"

import { useEffect } from "react"
import Heading from "../../../_components/Atoms/Heading"

export default function Error({
    error,
    reset
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Logging the error to the console
        console.error(error)
    }, [error])

    return (
        <div className="flex flex-col items-center p-24 py-164 md:py-264">
            <Heading type="h1" className="mb-16 text-center md:mb-32">
                It looks like <br />
                something went wrong
            </Heading>

            <ButtonPill
                type="button"
                aria-label="Return to home page"
                color="black"
                size="large"
                variant="primary"
                onClick={
                    // Attempt to recover by trying to re-render the segment
                    () => reset()
                }
            >
                Try again
            </ButtonPill>
        </div>
    )
}
